// Convert kebab-case to camelCase: my-page-asset > myPageAsset
import truncate from 'lodash/truncate';

export const camelize = s => s.replace(/-(.)/g, l => l[1].toUpperCase());

export const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);

export const truncated = (string, length = 50) => {
  return truncate(string, {
    length,

    // Allow truncated text end only in specific characters. This will
    // make the truncated text shorter than the length if the original
    // text has to be shortened and the substring ends in a separator.
    //
    // This ensures that the final text doesn't get cut in the middle
    // of a word.
    separator: /\s|,|\.|:|;/,
    omission: '…',
  });
};

export const extractYouTubeID = url => {
  const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts|live)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
  const match = url ? url.match(regExp) : null;

  return match ? match[1] : null;
};

/**
 * Sanitizes a keyword for safe display in UI
 * Escapes HTML special characters to prevent XSS attacks
 *
 * @param {string} keyword - The keyword to sanitize
 * @return {string} - Sanitized keyword safe for display
 */
export const sanitizeKeyword = keyword => {
  if (keyword == null) return '';
  return typeof keyword === 'string'
    ? keyword.replace(
        /[<>'"]/g,
        char => ({ '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char] || char)
      )
    : '';
};
